import { createFileRoute } from "@tanstack/react-router";
import { RouteGuard } from "@/components/RouteGuard";
import { CertificateManagement } from "@/lib/lazyPages";

export const Route = createFileRoute("/admin/certificates")({
  component: () => (
    <RouteGuard access={{ kind: "admin" }}>
      <CertificateManagement />
    </RouteGuard>
  ),
});
